
import { Link } from 'react-router-dom';

export function SoftwareFooter() {
  return (
    <footer className="bg-gray-950 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/5390af1b9222ae6e92dc7da25193e2e6/65a0e09d2eafecea725f43c7f76a00d5.png"
              alt="STI Logo"
              title="Servicio Técnico Informático"
              className="w-8 h-8 object-contain"
            />
            <span className="text-sm font-semibold">Servicio Técnico IT</span>
          </div>

          <div className="flex items-center gap-6">
            <Link to="/" className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
              Inicio
            </Link>
            <a href="#licencias" className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer">
              Licencias
            </a>
            <a
              href={`https://wa.me/5491140402887?text=${encodeURIComponent('Hola, consulto por licencias de software.')}`}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-gray-400 hover:text-neon-400 transition-colors cursor-pointer"
            >
              Contacto
            </a>
          </div>

          <div className="flex items-center gap-4 text-sm text-gray-500">
            <span>© 2024 STI</span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-neon-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
